import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, Home, BedDouble, CircleDollarSign, ArrowRight } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { useSite } from "@/lib/site";

const Field = ({ icon: Icon, value, onChange, children, testid }) => (
  <label className="relative flex items-center gap-3 border border-sand/70 bg-ivory px-4 h-14 hover:border-gold transition-colors">
    <Icon size={16} strokeWidth={1.3} className="text-midnight/60 shrink-0" />
    <select data-testid={testid} value={value} onChange={(e) => onChange(e.target.value)} className="w-full bg-transparent text-sm text-midnight outline-none appearance-none cursor-pointer">
      {children}
    </select>
  </label>
);

export const SearchBar = ({ initial = {} }) => {
  const { t, tr } = useLang();
  const { countries } = useSite();
  const nav = useNavigate();
  const [f, setF] = useState({ country: "", type: "", bedrooms: "", max_price: "", ...initial });
  const set = (k) => (v) => setF((o) => ({ ...o, [k]: v }));
  const go = () => nav(`/nehnutelnosti?${new URLSearchParams(Object.entries(f).filter(([, v]) => v)).toString()}`);
  return (
    <div data-testid="search-bar">
      <div className="text-[11px] tracking-[0.32em] uppercase text-midnight/70 mb-5">{t.search.title}</div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[1fr_1fr_1fr_1fr_auto] gap-3">
        <Field icon={MapPin} value={f.country} onChange={set("country")} testid="search-location">
          <option value="">{t.search.location}</option>
          {countries.map((c) => <option key={c.id} value={c.id}>{tr(c.name)}</option>)}
        </Field>
        <Field icon={Home} value={f.type} onChange={set("type")} testid="search-type">
          <option value="">{t.search.type}</option>
          {Object.entries(t.types).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </Field>
        <Field icon={BedDouble} value={f.bedrooms} onChange={set("bedrooms")} testid="search-bedrooms">
          <option value="">{t.search.bedrooms}</option>
          {[1, 2, 3, 4, 5, 6].map((n) => <option key={n} value={n}>{n}+</option>)}
        </Field>
        <Field icon={CircleDollarSign} value={f.max_price} onChange={set("max_price")} testid="search-price">
          <option value="">{t.search.price}</option>
          {[1000000, 2000000, 3000000, 5000000, 10000000].map((n) => <option key={n} value={n}>≤ € {(n / 1e6).toLocaleString()} M</option>)}
        </Field>
        <button onClick={go} data-testid="search-submit" className="btn-gold h-14 px-10 sm:col-span-2 lg:col-span-1">{t.search.go} <ArrowRight size={14} /></button>
      </div>
    </div>
  );
};
